jQuery(function ($) {
  $('.alert-inline.is-dismissible .alert__close').on('click', function () {
    $(this).closest('.alert-inline')
      .fadeOut(200, function () {
        $(this).remove();
      });
  });
});
